"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class DownloadIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { id: "Symbols", stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("path", { d: "M14.4615385,10.1538462 L18.1538462,10.1538462 L12,16.3076923 L5.84615385,10.1538462 L9.53846154,10.1538462 L9.53846154,4 L14.4615385,4 L14.4615385,10.1538462 Z M4,17.5384615 L20,17.5384615 L20,20 L4,20 L4,17.5384615 Z" })))));
    }
}
exports.DownloadIcon = DownloadIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/download.tsx
// module id = 2141
// module chunks = 0 1 2